import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {Container, Grid } from "@material-ui/core";
import Cognisphere from "../../assets/images/Cognisphere.png";
import Loader from "../../Components/Loader/Loader";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../Components/Header/Header";
import "./Home.scss";
import { MasterRouteLanding } from "../../Utilities/Utility";
import { isForgotPasswordAction, storeLandingMenuItemsAction } from "../../Redux/Actions/actions";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { ResetUserPassword } from "../../APIs/api_UserManagement";

import CloseIcon from "@material-ui/icons/Close";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    TextField,
    Button,
    InputAdornment,
    IconButton
} from "@material-ui/core";


export default function Home() {
    const dispatch = useDispatch();
    const userDetails = useSelector(
        (state) => state.storeUserDetailsReducer.userData
    );
    const isForgotPasswordClicked = useSelector(state => state.isForgotPasswordReducer);
    console.log("isForgotPasswordClicked", isForgotPasswordClicked);


    const [changePwdOpen, setChangePwdOpen] = useState(false);

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const isFirstLogin = userDetails?.changePassword === null;
    

    const [routes, setRoutes] = useState([]);
    const siteToken = useSelector((state) => state.saveBearerTokenReducer);
    const siemensToken = useSelector((state) => state.saveTokenReducer);
    
    const UID = useSelector((state) => state.saveUserIdReducer);
    console.log("UID", UID);
    const landingMenuItems = useSelector(state => state.storeLandingMenuItemsReducer.menuItems) || [];

    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [dialogContent, setDialogContent] = React.useState("");
    const [dialogTitle, setDialogTitle] = React.useState("");
   
    function getMenus() {
        if (userDetails.roleId == 2) {
                let filtered = MasterRouteLanding.filter((c) => c.roleId === 2 && c.menuName != 'Admin');
                setRoutes(filtered);
            }
            if (userDetails.roleId != 2) {
            let filtered = MasterRouteLanding.filter((c) => c.roleId === 1);
            setRoutes(filtered);
        }
        //let filtered = MasterRouteLanding.filter((c) => c.roleId === 1);
        //setRoutes(filtered);
    }
    var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;

    window.history.pushState({ path: newurl }, "", newurl);
    const [menuLoaded, setMenuLoaded] = useState(false);
    //function getLandingMenus() {
    //    const options = {
    //        method: "get",
    //        headers: {
    //            Authorization: "Bearer " + siteToken.token,
    //           // SiemensToken: siemensToken.token,
    //            UserEmail: userDetails.emailId,
    //            RoleName: userDetails.roleName,
    //           // Gid: userDetails.gid,
    //            Roleid: userDetails.roleId,
    //            userId: UID.id,

    //        },

    //    };
    //    return fetch("Role/GetLandingMenuData", options)
    //        .then((response) => response.json())
    //        .then((response) => {
    //            if (response) {
    //                console.log(response.result)

    //                dispatch(storeLandingMenuItemsAction(response.result));

    //            } else {

    //                dispatch(storeLandingMenuItemsAction(response.result));
    //            }
    //        })
    //        .catch((error) => {
    //            console.log("Error: " + error, "error");
    //        });
    //}
    const handleDialogOpen = (content, title) => {
        setDialogTitle(title);
        setDialogContent(content);
        setDialogOpen(true);
    };
    const handleClose = () => {
        setDialogOpen(false);
       // setPwdDialogOpen(false);
    };


    function getLandingMenus() {

        const roleId = Number(userDetails.roleId);

        const headers = {
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userDetails.emailId,
            RoleName: userDetails.roleName,
            RoleId: roleId,
            userId: UID.id
        };

        if (roleId !== 2) {
            if (userDetails.gid) {
                headers.Gid = userDetails.gid;
            }

            if (siemensToken?.token && siemensToken.token.trim() !== "") {
                headers.SiemensToken = siemensToken.token;
            }
        }

        console.log("FINAL HEADERS:", headers);

        return fetch("Role/GetLandingMenuData", {
            method: "GET",
            headers: headers
        })
            .then(async (response) => {
                const text = await response.text();

                if (!response.ok) {
                    console.error("API ERROR:", text);
                    throw new Error(text);
                }

                return JSON.parse(text);
            })
            .then((response) => {
                dispatch(storeLandingMenuItemsAction(response.result));
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    //const handleResetPassword = () => {

    //    if (!newPassword || !confirmPassword) {
    //        setPasswordError("All fields are required");
    //        return;
    //    }

    //    if (newPassword !== confirmPassword) {
    //        setPasswordError("Passwords do not match");
    //        return;
    //    }

    //    setPasswordError("");


    //    const data = {
    //        EmailId: forgotEmail,
    //        Password: newPassword,
    //        //GeneratedOTP: otpValue       
    //    };


    //    setIsLoader(true);

    //    ResetUserPassword(data)
    //        .then((res) => {
    //            setIsLoader(false);

    //            if (res) {
    //                handleDialogOpen("Password reset successful", "Success");

    //                setResetDialogOpen(false);

    //                // Optional: redirect to login
    //                // history.push("/login");

    //            } else {
    //                handleDialogOpen("Failed to reset password", "Error");
    //            }
    //        })
    //        .catch(() => {
    //            setIsLoader(false);
    //            handleDialogOpen("Something went wrong", "Error");
    //        });
    //};


    
        function handleChangePassword() {

        //  Step 1: Validation
        if (!newPassword || !confirmPassword) {
            setErrorMsg("All fields are required");
            return;
        }

        if (newPassword !== confirmPassword) {
            setErrorMsg("Passwords do not match");
            return;
            }

            //if (oldPassword == newPassword) {
            //    setErrorMsg("Please check New password");
            //    return;
            //}
            //if (oldPassword == confirmPassword) {
            //    setErrorMsg("Please check Confirm password");
            //    return;

            //}


        //  Old password validation (only for normal users)
        //if (!) {
        //    if (!oldPassword) {
        //        setErrorMsg("Old password is required");
        //        return;
        //    }isFirstLogin

        //    if (oldPassword !== userDetails.userPassword) {
        //        setErrorMsg("Old password is incorrect");
        //        return;
        //    }
        //}

        setErrorMsg("");

        //  Step 2: Prepare API data
        const data = {
            EmailId: userDetails.emailId,
            Password: newPassword,

            //  send old password only if required
          //  ...(!isFirstLogin && { OldPassword: oldPassword })
        };

        console.log("Sending Change Password Data:", data);

       // setIsLoader(true); // if you have loader

        //  Step 3: API Call
        ResetUserPassword(data)
            .then((res) => {

              //  setIsLoader(false);

                if (res?.response) {
                    setSuccessMsg(res?.responseMsg || "Password changed successfully");
                  
                    setChangePwdOpen(false);

                    // IMPORTANT: update local flag so dialog doesn't open again
                  //  userDetails.changePassword = 1;

                    // Optional: reload menus after password change
                    getLandingMenus();

                } else {
                    setErrorMsg(res?.ResponseMsg || "Failed to change password");
                }
            })
            .catch(() => {
                //setIsLoader(false);
                setErrorMsg("Something went wrong");
            });
    }



    useEffect(() => {
        console.log("userDetails", userDetails);
        console.log("siteToken", siteToken);
        console.log("siemensToken", siemensToken);
        //if (userDetails?.id > 0 && siteToken?.token !== "" && landingMenuItems?.length <= 0) {
        //    getLandingMenus();
        //}//earlier


        //if (userDetails?.changePassword === null && userDetails?.roleId === 2) {
        //    setChangePwdOpen(true); 
        //}

        if ((userDetails?.id > 0 || userDetails.userId > 0) && 
siteToken?.token &&
                siteToken.token.trim() !== "" &&
            !menuLoaded 
        ) {
            setMenuLoaded(true);
            getLandingMenus();
        }
        //newly added by Shivani
        dispatch(isForgotPasswordAction(false));
    }, [userDetails, siteToken]);
    //landingMenuItems removed from dependency--earlier was there
    return (
        <>
            <div className="potts-master-block">
                <Header />
                <main className="main-component">
                    {/* <img
            src={Cognisphere}
            alt="Cognisphere"
            className="homepage-cognisphere"
          /> */}
                    {landingMenuItems.length ? (
                        <div className="bg-landing-page">
                            <Container maxWidth="xl">
                                <Grid container className="homepage-container">
                                    <Grid item xs={12} sm={12} md={12} lg={5} className="z-9">
                                        <div className="logged-in-user">
                                            <h1 className="logged-in-user-heading">
                                                <span className="logged-in-greetings">Hello,{userDetails.firstName}</span>
                                               
                                            </h1>
                                            <p className="logged-in-project-desc">
                                                Welcome to Routine Test Certificate Tool
                                            </p>
                                        </div>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={7}
                                        className="landing-page-menu"
                                    >
                                        <Grid container spacing={2}>
                                            {landingMenuItems.map((item, index) => (
                                                <Grid item xs={12} sm={6} md={6} key={index}>
                                                    <Link to={item.menuLink} key={index}>
                                                        <div className="menu-item-container">
                                                            <div className="menu-item-text-block">
                                                                <span className="align-center ml-1">
                                                                    {item.menuName}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Container>
                        </div>
                    ) : (
                        <Loader />
                    )}

                    {userDetails.changePassword === null && userDetails.roleId==2 ?
                        <Dialog open={changePwdOpen} disableEscapeKeyDown>
                            <DialogTitle>Change Password</DialogTitle>

                            <DialogContent>

                                {/*  OLD PASSWORD (Only for normal user) */}
                                
                                    {/*<TextField*/}
                                    {/*    label="Old Password"*/}
                                    {/*    type={showOldPassword ? "text" : "password"}*/}
                                    {/*    fullWidth*/}
                                    {/*    margin="dense"*/}
                                    {/*    value={oldPassword}*/}
                                    {/*    onChange={(e) => setOldPassword(e.target.value)}*/}
                                    {/*    InputProps={{*/}
                                    {/*        endAdornment: (*/}
                                    {/*            <InputAdornment position="end">*/}
                                    {/*                <IconButton*/}
                                    {/*                    onClick={() => setShowOldPassword(!showOldPassword)}*/}
                                    {/*                >*/}
                                    {/*                    {showOldPassword ? <Visibility /> : <VisibilityOff />}*/}
                                    {/*                </IconButton>*/}
                                    {/*            </InputAdornment>*/}
                                    {/*        )*/}
                                    {/*    }}*/}
                                    {/*/>*/}
                                

                                {/* NEW PASSWORD */}
                                <TextField
                                    label="New Password"
                                    type={showNewPassword ? "text" : "password"}
                                    fullWidth
                                    margin="dense"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                                >
                                                    {showNewPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />

                                {/*  CONFIRM PASSWORD */}
                                <TextField
                                    label="Confirm Password"
                                    type={showConfirmPassword ? "text" : "password"}
                                    fullWidth
                                    margin="dense"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                >
                                                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />

                                {/*  Error */}
                                {errorMsg && (
                                    <p style={{ color: "red", marginTop: "8px" }}>{errorMsg}</p>
                                )}

                            </DialogContent>

                            <DialogActions>

                                {/*  Cancel disabled on first login */}
                                {!isFirstLogin && (
                                    <Button onClick={() => setChangePwdOpen(false)}>
                                        Cancel
                                    </Button>
                                )}

                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={handleChangePassword}
                                >
                                    Submit
                                </Button>

                            </DialogActions>
                        </Dialog> : <></>}


                    <Dialog open={dialogOpen} onClose={handleClose}>
                        <DialogTitle>
                            {dialogTitle}
                            <IconButton
                                aria-label="close"
                               // className={classes.closeButton}
                                onClick={handleClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>

                        <DialogContent>
                            <DialogContentText>
                                {dialogContent}
                            </DialogContentText>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>

                </main>
            </div>
        </>
    );
}
